import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SOCIETY_PORTAL, SOCIETY_PORTAL_LOGIN } from "../../../../Routing/routes";
import { registerValidation } from "../../../../validationSchema/SocietyController/authSchema";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../../../redux/actions/AuthActions/LoginAction";
import { ErrorMessage, Form, Formik } from "formik";
import CircularProgress from "@mui/material/CircularProgress";

const SignUp = () => {
    const dispatch = useDispatch();
    const [showPass, setShowPass] = useState(false);
    const { loading } = useSelector(state => state.loginReducer);

    const handleSaveClick = (values, { resetForm }) => {
        dispatch(register({ ...values, clearForm: () => { resetForm() } }));
    }

    return (
        <>
            <section className='auth bg-base d-flex flex-wrap'>
                <div className='auth-left d-lg-block d-none'>
                    <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                        <img src='/assets/images/auth/auth-img.png' alt='' />
                    </div>
                </div>
                <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                    {loading ? (
                        <div className="tw-text-center"><CircularProgress /></div>
                    ) : (
                        <div className='max-w-464-px mx-auto w-100'>
                            <div>
                                <h4 className='mb-12'>Society Portal Sign Up</h4>
                                <p className='mb-32 text-secondary-light text-lg'>
                                    Create your account to get started
                                </p>
                            </div>
                            <Formik
                                initialValues={{
                                    firstName: '',
                                    lastName: '',
                                    email: '',
                                    phone: '',
                                    password: '',
                                    confirmPassword: ''
                                }}
                                enableReinitialize={true}
                                validationSchema={registerValidation}
                                onSubmit={handleSaveClick}
                            >
                                {(formik) => (
                                    <Form>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:person' />
                                                </span>
                                                <input
                                                    type='text'
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='First Name'
                                                    name="firstName"
                                                    onChange={(e) => formik.setFieldValue('firstName', e.target.value)}
                                                    value={formik.values.firstName}
                                                />
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`firstName`} />
                                            </div>
                                        </div>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:person' />
                                                </span>
                                                <input
                                                    type='text'
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='Last Name'
                                                    name="lastName"
                                                    onChange={(e) => formik.setFieldValue('lastName', e.target.value)}
                                                    value={formik.values.lastName}
                                                />
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`lastName`} />
                                            </div>
                                        </div>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:envelope' />
                                                </span>
                                                <input
                                                    type='email'
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='Email'
                                                    name="email"
                                                    onChange={(e) => formik.setFieldValue('email', e.target.value)}
                                                    value={formik.values.email}
                                                />
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`email`} />
                                            </div>
                                        </div>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:phone' />
                                                </span>
                                                <input
                                                    type='number'
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='Phone'
                                                    name="phone"
                                                    onChange={(e) => formik.setFieldValue('phone', e.target.value)}
                                                    value={formik.values.phone}
                                                />
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`phone`} />
                                            </div>
                                        </div>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:lock' />
                                                </span>
                                                <input
                                                    type={showPass ? 'text' : 'password'}
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='Password'
                                                    name="password"
                                                    onChange={(e) => formik.setFieldValue('password', e.target.value)}
                                                    value={formik.values.password}
                                                />
                                                {showPass ? (
                                                    <span
                                                        onClick={() => setShowPass(!showPass)}
                                                        className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                                    ></span>
                                                ) : (
                                                    <span
                                                        onClick={() => setShowPass(!showPass)}
                                                        className="toggle-password ri-eye-off-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                                    ></span>
                                                )}
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`password`} />
                                            </div>
                                        </div>
                                        <div className="mb-16">
                                            <div className='icon-field'>
                                                <span className='icon top-50 translate-middle-y'>
                                                    <Icon icon='f7:lock' />
                                                </span>
                                                <input
                                                    type='text'
                                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                                    placeholder='Confirm Password'
                                                    name="confirmPassword"
                                                    onChange={(e) => formik.setFieldValue('confirmPassword', e.target.value)}
                                                    value={formik.values.confirmPassword}
                                                />
                                            </div>
                                            <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                <ErrorMessage name={`confirmPassword`} />
                                            </div>
                                        </div>
                                        <button
                                            type='submit'
                                            className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                                        >
                                            Sign Up
                                        </button>
                                        <div className='mt-32 center-border-horizontal text-center'>
                                            <span className='bg-base z-1 px-4'>Or sign up with</span>
                                        </div>
                                        <div className='mt-32 text-center text-sm'>
                                            <p className='mb-0'>
                                                Already have an account?{" "}
                                                <Link to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN} className='text-primary-600 fw-semibold'>
                                                    Sign In
                                                </Link>
                                            </p>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
};

export default SignUp;
